// PRD 11 §3.6 Video block — title + Video URL (https://, YouTube/Vimeo) +
// showText toggle + optional description.
// ADM.018 / PRD v1.3: video is URL-ONLY — MP4 file upload is out of scope.
// The block chrome (position label, drag handle, delete) is owned by
// ContentBlockList; this component renders only the block body.

import { useTranslation } from 'react-i18next';

import type { ContentBlock } from '../types/counseling-manual.types';
import { BLOCK_DESC_MAX, VIDEO_TITLE_MAX } from '../utils/validate-form';

interface VideoBlockEditorProps {
  block: ContentBlock;
  disabled?: boolean;
  onChange: (patch: Partial<ContentBlock>) => void;
}

export function VideoBlockEditor({ block, disabled = false, onChange }: VideoBlockEditorProps) {
  const { t } = useTranslation('counseling-manual');

  return (
    <>
      <input
        type="text"
        className="form-field__input"
        value={block.title}
        onChange={(e) => onChange({ title: e.target.value })}
        placeholder={t('blocks.videoTitlePlaceholder')}
        maxLength={VIDEO_TITLE_MAX}
        disabled={disabled}
        style={{ marginBottom: 6 }}
      />

      <input
        type="url"
        inputMode="url"
        className="form-field__input"
        value={block.url ?? ''}
        onChange={(e) => onChange({ url: e.target.value })}
        placeholder={t('blocks.videoUrlPlaceholder')}
        disabled={disabled}
        style={{ marginBottom: 6 }}
      />

      <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer', marginBottom: 4 }}>
        <input
          type="checkbox"
          checked={block.showText}
          onChange={(e) => onChange({ showText: e.target.checked })}
          disabled={disabled}
          style={{ width: 14, height: 14, accentColor: 'var(--info)' }}
        />
        {t('blocks.showText')}
      </label>
      {block.showText ? (
        <textarea
          className="form-field__textarea"
          style={{ minHeight: 60 }}
          value={block.text}
          onChange={(e) => onChange({ text: e.target.value })}
          placeholder={t('blocks.videoDescPlaceholder')}
          maxLength={BLOCK_DESC_MAX}
          disabled={disabled}
        />
      ) : null}
    </>
  );
}
